import React from "react";

import { FloatingWindowsProvider } from "src/base-components/FloatingWindow/FloatingWindowsProvider";
import { FeatureQueryHeader } from "src/featureCatalogue/Features/FeatureQueryHeader";

type FeatureCatalogueWrapperProps = {
  subHeaderRightContent?: React.ReactNode;
  children: React.ReactNode;
  showSubHeader?: boolean;
  breadcrumbs?: { key: string; breadcrumb: React.ReactNode }[];
  headerSideContent?: React.ReactNode;
};

export const FeatureCatalogueWrapper: React.FC<
  FeatureCatalogueWrapperProps
> = ({
  subHeaderRightContent,
  children,
  showSubHeader = true,
  breadcrumbs,
  headerSideContent,
}) => {
  return (
    <FloatingWindowsProvider>
      <div className="flex h-full flex-col" data-loc="catalogue-wrapper">
        <FeatureQueryHeader
          breadcrumbs={breadcrumbs ?? []}
          showSubHeader={showSubHeader}
          sideContent={headerSideContent}
          subHeaderRightContent={subHeaderRightContent}
        />
        <div className="m-auto flex min-h-0 w-full max-w-[1800px] flex-1 flex-col gap-y-5.5 p-5">
          {children}
        </div>
      </div>
    </FloatingWindowsProvider>
  );
};
